import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsAccordionContentItemIcon = function (props) {
    var option = props.option, accordionConfig = props.accordionConfig, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-accordion-content-item-icon", { ref: ref, option: option ? (typeof option === "string" ? option : JSON.stringify(option)) : undefined, "accordion-config": accordionConfig ? (typeof accordionConfig === "string" ? accordionConfig : JSON.stringify(accordionConfig)) : undefined }, children));
};
export default VeltNotificationsPanelSettingsAccordionContentItemIcon;
